<script lang="ts">
    import { events, articles } from "../../store"

    import { apiBaseURL } from "../../config"

    import Sidebar from "../page/Sidebar.svelte"
    import ContentArticle from "../page/ContentArticle.svelte"
    import Event from "../page/Event.svelte"
    import CloudCarousel from "../page/CloudCarousel.svelte"

    export let id: string

    let article: SWArticle

    $: if ($articles) {
        $articles.forEach((a) => {
            if (a.id === id) {
                article = a
            }
        })
    }
</script>

<div class="container">
    <div class="row">
        <div class="col-md-10">
            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />

            {#if article}
                <article class="article-details">
                    {#if article?.image && !article?.details}
                        <img
                            src="{`${apiBaseURL}articles/${article?.id}/${article?.image?.src}?filter=l`}"
                            alt="{article?.image?.path}"
                            class="mb-lg"
                        />
                    {/if}

                    <div class="article-content">
                        {#if !article?.details?.length}
                            {#if article?.title}
                                <h1 class="article-title">{article?.title}</h1>
                            {/if}

                            {#if article?.subtitle}
                                <div class="article-subtitle mb-md">
                                    {article?.subtitle}
                                </div>
                            {/if}
                        {/if}

                        {#if article?.details}
                            <div class="row content-blocks">
                                {#each article?.details || [] as a}
                                    <ContentArticle
                                        article="{a}"
                                        id="{article?.id}"
                                    />
                                {/each}
                            </div>
                        {/if}
                    </div>
                </article>
            {/if}

            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />

            <div class="layout layout-vertical layout-gap-md">
                <h2>Veranstaltungen</h2>
                {#each $events || [] as event}
                    {#if event.position === "content"}
                        <Event event="{event}" />
                    {/if}
                {/each}
            </div>

            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />

            <div class="mt-lg mb-lg">
                <CloudCarousel />
            </div>
        </div>
        <div class="col-md-2">
            <Sidebar />
        </div>
    </div>
</div>
